import React from 'react';

/**
 * This will return the current component. In future we can use this to
 * perhaps fade in to the next component
 */
export default class MoltenRoot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      component: null
    };
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  setComponent = component => {
    this.setState({
      component
    });
  };
  render() {
    const {
      component
    } = this.state;
    return component;
  }
}